export enum DefectSeverities {
	BLOCKER = 'BLOCKER',
	CRITICAL = 'CRITICAL',
	HIGH = 'HIGH',
	MEDIUM = 'MEDIUM',
	LOW = 'LOW',
	MINOR = 'MINOR',
}
